"use client";
import { useDispatch, useSelector } from "react-redux";
import TestimonialsCarousel from "../components/TestimonialsCarousel/TestimonialsCarousel";
import { useEffect } from "react";
import {
  fetchAssistanceData,
  selectAllAssistances,
} from "@/slice/fetchAssistances";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import TestimonialCard from "../components/TestimonialsCarousel/TestimonialCard/TestimonialCard";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import Detailslist from "@/components/Detailslist/Detailslist";
import { expertFilter } from "@/utils/data";
import Treatments from "@/components/Treatments/Treatments";
import Impact from "@/components/Impact/Impact";
import {
  fetchCities,
  fetchCountries,
  selectAllCities,
  selectAllCountries,
} from "@/slice/countryCitySlice";
import FullScreenLoader from "../components/FullScreenLoader/FullScreenLoader";

export default function Page() {
  const dispatch = useDispatch();
  const assistances = useSelector(selectAllAssistances);
  const status = useSelector((state) => state.assistances.status);
  const countries = useSelector(selectAllCountries);
  const cities = useSelector(selectAllCities);
  const lang = useSelector((state) => state.locale.locale);
  useEffect(() => {
    dispatch(fetchCountries());
    dispatch(fetchCities());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAssistanceData({ locale: lang }));
  }, [dispatch]);

  const cityFilter = {
    id: expertFilter.length + 1,
    title: "Cities",
    values: cities?.data?.map((city) => ({
      id: city.name,
      name: city.name.charAt(0).toUpperCase() + city.name.slice(1),
    })),
  };

  const countryFilter = {
    id: 1,
    title: "Countries",
    values: countries?.data?.map((country) => ({
      id: country.name,
      name: country.name.charAt(0).toUpperCase() + country.name.slice(1),
    })),
  };

  const updatedExpertFilter = [cityFilter, countryFilter];

  const props = {
    heading: "Search accordingly your convenience",
    filterData: updatedExpertFilter,
  };

  return (
    <div>
      <BreadCrumbs />
      <div className="testimonialsContainer">
        <Detailslist props={props}>
          {assistances?.data?.length > 0 &&
            assistances?.data.map((testimonial, i) => {
              return <TestimonialCard key={i} testimonial={testimonial} />;
            })}
        </Detailslist>

        <br />
        <Treatments numOfRows={2} />
        <FullScreenLoader isLoading={status == "loading"} />
        <Impact />
      </div>
    </div>
  );
}
